let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("9HEeX")).then(() => parcelRequire('82adB'));